// Strings of the Applications page, Arabic and English (same keys).

const ar = {
  title: "التطبيقات",
  loading: "جارٍ تحميل التطبيقات…",
  loadError: "تعذّر تحميل التطبيقات",
  retry: "إعادة المحاولة",
  empty: "لا توجد تطبيقات متاحة",
  branchesCount: (active, total) => `${active} / ${total} فروع`,
  lastMonth: "إيراد الشهر الماضي",
  queue: "طلبات الإدارة",
  close: "إغلاق",
  cancel: "إلغاء",
  back: "رجوع",
  next: "التالي",
  save: "حفظ",
  yes: "نعم",
  status: {
    notActivated: "غير مفعّل",
    subscriptionPending: "اشتراك معلّق",
    subscriptionSent: "تم إرسال الاشتراك",
    subscriptionCompleted: "اكتمل الاشتراك",
    integrationInProgress: "جاري الربط",
    integrationRejected: "مرفوض",
    active: "فعال",
    activeNoBranches: "لا فروع فعالة",
    closed: "غير فعال",
    pending: "معلّق",
    sending: "جاري الإرسال",
    sent: "تم الإرسال",
    failed: "فشل الإرسال",
    completed: "مكتمل",
    cancelled: "ملغي",
    inactive: "غير فعال",
    unconfigured: "غير مهيأ",
  },
  action: {
    activate: "تفعيل",
    manageRequest: "إدارة الطلب",
    viewRequest: "عرض الطلب",
    viewIntegration: "عرض الربط",
    completeIntegration: "إكمال الربط",
    manage: "إدارة",
    reactivate: "إعادة التفعيل",
    view: "عرض",
  },
  activate: {
    title: (app) => `تفعيل ${app}`,
    question: "هل لدى المتجر حساب في هذا التطبيق؟",
    subscribe: "اشتراك",
    subscribeHint: "ليس لدى المتجر حساب ويريد التسجيل في التطبيق.",
    integrate: "ربط",
    integrateHint: "لدى المتجر حساب بالفعل ويريد ربطه بـ LUD.",
  },
  subscribe: {
    title: (app) => `الاشتراك في ${app}`,
    steps: ["اكتمال البيانات", "اختيار الفروع", "معاينة الرسالة"],
    checking: "جارٍ التحقق من اكتمال بيانات المتجر…",
    incompleteTitle: (percent) => `بيانات المتجر مكتملة بنسبة ${percent}% فقط`,
    incompleteBody: "يجب إكمال جميع البيانات الإلزامية (100%) قبل إرسال طلب الاشتراك. لم يتم إنشاء أي طلب.",
    missing: "البيانات الناقصة",
    goCompletion: "الانتقال إلى اكتمال البيانات",
    pickBranches: "اختر فرعاً أو أكثر للتسجيل. لن يتم تسجيل أي فرع تلقائياً.",
    noEligible: "لا يوجد أي فرع مكتمل. أكمل بيانات الفروع أولاً.",
    selectedCount: (n) => `${n} فرع محدد`,
    previewTitle: "معاينة رسالة التسجيل",
    to: "إلى",
    cc: "نسخة",
    subject: "الموضوع",
    body: "نص الرسالة",
    branches: "الفروع المحددة",
    sendNow: "إرسال الآن",
    savePending: "حفظ كطلب معلّق",
    previewHint: "لن تُرسل الرسالة قبل تأكيدك. إغلاق النافذة لا ينشئ أي طلب.",
    sentOk: "قبل مزوّد البريد الرسالة. الاشتراك يكتمل بعد تأكيد الإدارة.",
    savedOk: "تم حفظ الطلب كمعلّق ولم يُرسل أي بريد.",
    failedSaved: "تم حفظ الطلب لكن فشل الإرسال. يمكنك إعادة المحاولة من إدارة الطلب.",
    alreadyRequested: "يوجد طلب لهذا الفرع",
  },
  missingFields: {
    name: "الاسم",
    location: "رابط الموقع",
    phone: "رقم الهاتف",
    city: "المدينة",
    status: "الحالة (يجب أن يكون فعالاً)",
  },
  integrate: {
    title: (app) => `ربط ${app}`,
    account: "بيانات حساب التطبيق",
    accountId: "رقم الحساب",
    accountEmail: "بريد الحساب",
    accountPassword: "كلمة المرور",
    passwordKeep: "اتركها فارغة للإبقاء على المحفوظة",
    integrationStatus: "حالة الربط",
    afterSubmit: "ستصبح «جاري الربط» بعد الإرسال",
    manager: "مدير الحساب في التطبيق",
    managerName: "اسم المدير",
    managerPhone: "جوال المدير",
    managerEmail: "بريد المدير",
    branches: "ربط الفروع",
    branchesHint: "اختر الفروع وأدخل معرّف واسم الفرع في التطبيق لكل فرع على حدة.",
    appId: "معرّف الفرع في التطبيق",
    appName: "اسم الفرع في التطبيق",
    submit: "إرسال للمراجعة",
    submitted: "تم إرسال بيانات الربط للمراجعة.",
    unavailable: "غير متاح",
    rejectedNote: "تم رفض الطلب السابق. عدّل البيانات ثم أعد الإرسال.",
    waitSubscription: "طلب الاشتراك لهذا الفرع لم يكتمل بعد",
    alreadyActive: "الفرع فعال بالفعل",
    required: "مطلوب",
    invalid: "قيمة غير صالحة",
    duplicate: "مكرر بين الفروع",
    noBranches: "اختر فرعاً واحداً على الأقل",
  },
  manage: {
    title: (app) => app,
    loadError: "تعذّر تحميل التفاصيل",
    requests: "طلبات الاشتراك",
    noRequests: "لا توجد طلبات اشتراك",
    integration: "الربط",
    account: "الحساب",
    manager: "مدير الحساب",
    reason: "سبب الرفض",
    branches: "الفروع",
    appId: "المعرّف",
    appName: "الاسم في التطبيق",
    statusCol: "الحالة",
    history: "السجل",
    attempts: "المحاولات",
    send: "إرسال",
    retry: "إعادة الإرسال",
    cancelRequest: "إلغاء الطلب",
    complete: "تأكيد اكتمال الاشتراك",
    possiblyDelivered: "انقطع الإرسال؛ قد يكون المزوّد قبل الرسالة.",
    edit: "تعديل بيانات الربط",
    integrateNow: "إكمال الربط",
    addBranches: "إضافة فروع",
    approve: "اعتماد المحدد",
    reject: "رفض",
    rejectReason: "سبب الرفض (مطلوب)",
    deactivateStore: "إيقاف التطبيق للمتجر",
    reactivateStore: "إعادة تفعيل التطبيق للمتجر",
    activateBranches: "تفعيل المحدد",
    deactivateBranches: "إيقاف المحدد",
    showPassword: "إظهار كلمة المرور",
    hidePassword: "إخفاء",
    password: "كلمة المرور",
    readOnly: "عرض فقط — ليست لديك صلاحية التعديل.",
    reactivateInfo: "التطبيق غير فعال. تتم إعادة التفعيل بواسطة الإدارة.",
    done: "تم تنفيذ الإجراء.",
    selectBranches: "حدد الفروع أولاً",
    none: "—",
    pendingBranchHint: "بانتظار موافقة الإدارة",
    storeLevel: "حالة المتجر",
    completeNote: "ملاحظة (اختياري)",
  },
  confirm: {
    cancelTitle: "إلغاء الطلب",
    cancelMsg: "سيتم إلغاء الطلب مع الاحتفاظ بسجله، ولن يُرسل أي بريد. يمكنك إنشاء طلب جديد لاحقاً.",
    deactivateStoreTitle: "إيقاف التطبيق للمتجر",
    deactivateStoreMsg: "ستصبح كل فروع التطبيق غير فعالة تشغيلياً دون حذف أي بيانات أو حسابات.",
    deactivateBranchesTitle: "إيقاف الفروع المحددة",
    deactivateBranchesMsg: "سيتم إيقاف الفروع المحددة فقط ولن تُحذف بياناتها.",
    completeTitle: "تأكيد اكتمال الاشتراك",
    completeMsg: "سيتمكن المتجر بعدها من إكمال بيانات الربط.",
    sendTitle: "إرسال الطلب",
    sendMsg: "سيتم إرسال رسالة التسجيل الآن.",
    yes: "تأكيد",
    no: "تراجع",
  },
  queueModal: {
    title: "طلبات التطبيقات",
    subs: "طلبات الاشتراك",
    integrations: "ربط بانتظار الاعتماد",
    none: "لا توجد طلبات",
    review: "مراجعة",
    store: "المتجر",
  },
  flow: {
    summaryApp: "التطبيق",
    storeDeactivateTitle: (app) => `إيقاف تطبيق ${app} للمتجر`,
    storeDeactivateIntro: "سيُطلب إيقاف التطبيق بالكامل للمتجر، فتتوقف كل فروعه الفعالة تشغيلياً. تبقى الفروع فعالة حتى توافق الإدارة، ولا تُحذف أي بيانات أو حسابات.",
    storeDeactivateConfirm: "سيبقى التطبيق وكل فروعه فعالة حتى توافق الإدارة، ثم يُوقف التطبيق للمتجر بالكامل. لا تُحذف أي بيانات.",
    deactivateStoreBtn: "إيقاف التطبيق للمتجر",
    wholeAppTag: "التطبيق كاملاً",
    affectedBranches: "الفروع الفعالة المتأثرة",
    reasonLabel: "سبب الإيقاف",
    reasonHint: "اكتب سبب طلب الإيقاف (5 أحرف على الأقل). تراه الإدارة قبل الموافقة أو الرفض.",
    reasonRequired: "سبب الإيقاف مطلوب",
    reasonInvalid: "اكتب سبباً واضحاً (5 أحرف على الأقل)",
    searchBranches: "ابحث في الفروع",
    noMatch: "لا توجد فروع مطابقة",
    removeBranch: "إزالة",
    originBranch: "الفرع الحالي",
    activateBtn: "تفعيل فروع",
    deactivateBtn: "إيقاف فروع",
    integrateSteps: ["الحساب", "مدير الحساب", "الفروع", "المراجعة"],
    activateSteps: ["اختيار الفروع", "التأكيد"],
        editTitle: (app) => `تعديل بيانات ${app}`,
    editingRequest: (ref) => `تعديل الطلب ${ref}`,
    stepOf: (n, total) => `الخطوة ${n} من ${total}`,
    reviewHint: "ستُرسل هذه البيانات كطلب بحالة «جاري المراجعة». لا يتغير أي شيء فعلياً قبل موافقة الإدارة.",
    passwordMasked: "••••••••",
    passwordUnchanged: "دون تغيير (المحفوظة)",
    passwordNew: "كلمة مرور جديدة",
    submitRequest: "إرسال الطلب",
    saveChanges: "حفظ التعديلات",
    requestSent: "تم إرسال الطلب وهو الآن قيد المراجعة.",
    requestUpdated: "تم تحديث الطلب وسيُراجع بنسخته الجديدة.",
    noBranchesSelected: "اختر فرعاً واحداً على الأقل",
    selectedBranches: "الفروع المحددة",
    activateTitle: (app) => `تفعيل فروع ${app}`,
    activatePick: "اختر الفروع التي تريد تفعيلها. الفروع الفعالة لن تتأثر.",
    activateNone: "لا توجد فروع مؤهلة للتفعيل. تحتاج الفروع إلى بيانات ربط (معرّف واسم في التطبيق).",
    activateGuide: "أكمل بيانات الربط للفروع أولاً.",
    editInfo: "تعديل بيانات الربط",
    activateConfirm: "سيُرسل طلب تفعيل للفروع التالية فقط. تبقى بقية الفروع كما هي.",
    activateSubmit: "إرسال طلب التفعيل",
    deactivateTitle: (app) => `إيقاف فروع ${app}`,
    deactivatePick: "اختر الفروع الفعالة التي تريد إيقافها.",
    deactivateNone: "لا توجد فروع فعالة.",
    deactivateConfirm: "ستبقى الفروع المحددة فعالة حتى توافق الإدارة، ثم تُوقف هذه الفروع فقط. لا تتغير بيانات الحساب أو المعرفات ولا يُحذف أي شيء.",
    deactivateSubmit: "إرسال طلب الإيقاف",
    willChange: "ستتغير حالتها",
    unaffected: "بقية الفروع لن تتأثر",
    ineligible: "غير مؤهل",
    needsInfo: "بحاجة لبيانات ربط",
    hasPending: "عليه طلب قيد المراجعة",
    pendingBadge: (n) => `${n} قيد المراجعة`,
  },
  branchManager: {
    button: "إدارة التطبيقات",
    title: (branch) => `تطبيقات الفرع — ${branch}`,
    hint: "حالة كل تطبيق لهذا الفرع. أي تغيير يُرسل كطلب وتوافق عليه الإدارة.",
    loadError: "تعذّر تحميل تطبيقات الفرع",
    subscribe: "اشتراك",
    integrate: "ربط",
    editInfo: "تعديل البيانات",
    activate: "تفعيل",
    deactivate: "إيقاف",
    requests: "الطلبات",
    pendingRequest: "طلب قيد المراجعة",
    subscription: "الاشتراك",
    readOnly: "عرض فقط — ليست لديك صلاحية التعديل.",
  },
  branchAccounts: {
    colApp: "التطبيق",
    colId: "معرّف الحساب",
    colName: "اسم الحساب",
    colStatus: "الحالة",
    colActions: "الإجراءات",
    addTitle: (app) => `إضافة حساب ${app}`,
    editTitle: (app) => `تعديل حساب ${app}`,
    fieldId: "معرّف الحساب (الفرع في التطبيق)",
    fieldName: "اسم الحساب (الفرع في التطبيق)",
    submit: "إرسال للمراجعة",
    modalNote: "يُرسل التعديل كطلب ويُطبّق بعد موافقة الإدارة. حالة الفرع لا تتغير.",
    duplicate: "هذا المعرّف مستخدم في فرع آخر",
    title: "حسابات التطبيقات",
    shared: "حساب المتجر (مشترك بين كل الفروع)",
    branchOnly: "بيانات هذا الفرع",
    account: "الحساب",
    manager: "مدير الحساب",
    password: "كلمة المرور",
    stored: "محفوظة (لا تُعرض)",
    notSet: "غير مضافة",
    add: "إضافة",
    edit: "تعديل",
    branchId: "معرّف الفرع",
    branchName: "اسم الفرع",
    status: "حالة الربط",
    approvalNote: "التعديلات تُرسل كطلب وتُطبّق بعد موافقة الإدارة.",
    noApps: "لا توجد بيانات تطبيقات",
    pending: "طلب قيد المراجعة",
  },
  requestTypes: { mapping: "تعديل بيانات حساب", integration: "ربط", activation: "تفعيل فروع", deactivation: "إيقاف فروع" },
  changeStatus: { inprogress: "قيد المراجعة", approved: "معتمد", rejected: "مرفوض", cancelled: "ملغي" },
  changes: {
    title: "طلبات الربط والتفعيل والإيقاف",
    none: "لا توجد طلبات",
    edit: "تعديل",
    cancel: "إلغاء الطلب",
    review: "مراجعة",
    by: "بواسطة",
    version: (n) => `نسخة ${n}`,
    rejection: "سبب الرفض",
    cancelTitle: "إلغاء الطلب",
    cancelMsg: "سيُلغى الطلب مع الاحتفاظ بسجله ولن يتغير أي شيء فعلياً.",
  },
  reviewModal: {
    wholeApp: "طلب إيقاف التطبيق بالكامل للمتجر: يُغلق حساب المتجر وتتوقف كل الفروع تشغيلياً، وتبقى إعدادات الفروع محفوظة.",
    deactivationReason: "سبب الإيقاف",
    title: (type) => `مراجعة طلب ${type}`,
    current: "الحالي",
    proposed: "المقترح",
    account: "الحساب",
    manager: "مدير الحساب",
    branches: "الفروع",
    statusChange: "تغيير الحالة",
    password: "كلمة المرور",
    passwordChanged: "ستُحدَّث",
    passwordUnchanged: "دون تغيير",
    approve: "اعتماد",
    reject: "رفض",
    reason: "سبب الرفض (مطلوب)",
    unchanged: "دون تغيير",
    stale: "تغيّر الطلب بعد فتحه. تم تحميل النسخة الأحدث، راجعها من جديد.",
    history: "السجل",
  },
  errors: {
    CONFLICTING_REQUEST: "يوجد طلب قيد المراجعة لأحد الفروع المحددة",
    STALE_VERSION: "تغيّر الطلب بواسطة شخص آخر. أعد تحميله",
    STALE_REVIEW: "تغيّر الطلب بعد فتحه. راجع النسخة الأحدث",
    NOT_EDITABLE: "لا يمكن تعديل هذا الطلب في حالته الحالية",
    NOT_PENDING: "تم البت في هذا الطلب مسبقاً",
    INTEGRATION_MISSING: "أكمل بيانات الربط قبل تفعيل الفروع",
    INTEGRATION_NOT_APPROVED: "لم تتم الموافقة على الربط بعد",
    BRANCH_NOT_ACTIVE: "يمكن إيقاف الفروع الفعالة فقط",
    DUPLICATE_APP_ID: "معرّف فرع في التطبيق مستخدم الآن في فرع آخر",
    INVALID_TYPE: "نوع طلب غير معروف",
    ACCESS_DENIED: "ليست لديك صلاحية لهذا الإجراء",
    STORE_INCOMPLETE: "بيانات المتجر غير مكتملة",
    NO_BRANCHES: "اختر فرعاً واحداً على الأقل",
    BRANCH_NOT_ELIGIBLE: "أحد الفروع المحددة غير مكتمل البيانات",
    BRANCH_NOT_IN_STORE: "فرع محدد لا يتبع هذا المتجر",
    DUPLICATE_REQUEST: "يوجد طلب تسجيل لأحد الفروع المحددة",
    APP_EMAIL_NOT_CONFIGURED: "لم يتم ضبط بريد هذا التطبيق. تواصل مع الدعم",
    APP_EMAIL_INVALID: "بريد التطبيق المضبوط غير صالح",
    STORE_EMAIL_INVALID: "بريد المتجر مفقود أو غير صالح",
    EMAIL_DISABLED: "إرسال البريد معطّل على الخادم",
    ALREADY_SENDING: "الطلب قيد الإرسال حالياً",
    ALREADY_SENT: "تم إرسال الطلب بالفعل",
    CANNOT_CANCEL: "لا يمكن إلغاء هذا الطلب في حالته الحالية",
    NOT_SENT: "يمكن تأكيد الاكتمال بعد الإرسال فقط",
    SUBSCRIPTION_NOT_COMPLETED: "طلب الاشتراك لفرع محدد لم يكتمل بعد",
    INTEGRATION_CLOSED: "الربط غير فعال. تتم إعادة التفعيل بواسطة الإدارة",
    INTEGRATION_ACTIVE: "لا يمكن تغيير حساب ربط فعال من هنا",
    BRANCH_ALREADY_ACTIVE: "أحد الفروع المحددة فعال بالفعل",
    VALIDATION_FAILED: "راجع الحقول المحددة",
    REASON_REQUIRED: "سبب الرفض مطلوب",
    STORE_NOT_ACTIVE: "التطبيق غير فعال للمتجر. أعد تفعيله أولاً",
    BRANCH_NOT_MAPPED: "فرع محدد ليس له معرّف في التطبيق",
    SEND_FAILED: "فشل إرسال البريد",
    generic: "حدث خطأ. حاول مرة أخرى",
  },
};

const en = {
  title: "Applications",
  loading: "Loading applications…",
  loadError: "Could not load applications",
  retry: "Retry",
  empty: "No applications available",
  branchesCount: (active, total) => `${active} / ${total} branches`,
  lastMonth: "Last month revenue",
  queue: "Requests queue",
  close: "Close",
  cancel: "Cancel",
  back: "Back",
  next: "Next",
  save: "Save",
  yes: "Yes",
  status: {
    notActivated: "Not activated",
    subscriptionPending: "Subscription pending",
    subscriptionSent: "Subscription sent",
    subscriptionCompleted: "Subscription completed",
    integrationInProgress: "In progress",
    integrationRejected: "Rejected",
    active: "Active",
    activeNoBranches: "No active branches",
    closed: "Deactivated",
    pending: "Pending",
    sending: "Sending",
    sent: "Sent",
    failed: "Failed",
    completed: "Completed",
    cancelled: "Cancelled",
    inactive: "Inactive",
    unconfigured: "Not configured",
  },
  action: {
    activate: "Activate",
    manageRequest: "Manage Request",
    viewRequest: "View Request",
    viewIntegration: "View Integration",
    completeIntegration: "Complete Integration",
    manage: "Manage",
    reactivate: "Reactivate",
    view: "View",
  },
  activate: {
    title: (app) => `Activate ${app}`,
    question: "Does the store already have an account with this application?",
    subscribe: "Subscribe",
    subscribeHint: "The store has no account yet and wants to register with the application.",
    integrate: "Integrate",
    integrateHint: "The store already has an account and wants to connect it to LUD.",
  },
  subscribe: {
    title: (app) => `Subscribe to ${app}`,
    steps: ["Store completion", "Branches", "Email preview"],
    checking: "Checking store completion…",
    incompleteTitle: (percent) => `Store information is only ${percent}% complete`,
    incompleteBody: "All mandatory store information must be complete (100%) before a registration request can be sent. No request was created.",
    missing: "Missing information",
    goCompletion: "Go to Completion",
    pickBranches: "Select one or more branches to register. No branch is registered automatically.",
    noEligible: "No branch is complete yet. Complete the branch information first.",
    selectedCount: (n) => `${n} branch(es) selected`,
    previewTitle: "Registration email preview",
    to: "To",
    cc: "CC",
    subject: "Subject",
    body: "Message",
    branches: "Selected branches",
    sendNow: "Send now",
    savePending: "Save as pending",
    previewHint: "Nothing is sent until you confirm. Closing this window creates no request.",
    sentOk: "The mail provider accepted the message. The subscription completes after LUD confirms it.",
    savedOk: "The request was saved as pending. No email was sent.",
    failedSaved: "The request was saved but sending failed. You can retry from Manage Request.",
    alreadyRequested: "A request exists for this branch",
  },
  missingFields: {
    name: "Name",
    location: "Location URL",
    phone: "Phone",
    city: "City",
    status: "Status (must be active)",
  },
  integrate: {
    title: (app) => `Integrate ${app}`,
    account: "Application account",
    accountId: "Account ID",
    accountEmail: "Account email",
    accountPassword: "Account password",
    passwordKeep: "Leave empty to keep the saved one",
    integrationStatus: "Integration status",
    afterSubmit: "Becomes “In progress” after submitting",
    manager: "Account manager at the application",
    managerName: "Manager name",
    managerPhone: "Manager phone",
    managerEmail: "Manager email",
    branches: "Branch integration",
    branchesHint: "Select branches and enter each branch's own application ID and name.",
    appId: "Branch ID in the application",
    appName: "Branch name in the application",
    submit: "Submit for review",
    submitted: "Integration details were submitted for review.",
    unavailable: "Unavailable",
    rejectedNote: "The previous submission was rejected. Update the details and resubmit.",
    waitSubscription: "This branch's registration request is not completed yet",
    alreadyActive: "Branch is already active",
    required: "Required",
    invalid: "Invalid value",
    duplicate: "Duplicate across branches",
    noBranches: "Select at least one branch",
  },
  manage: {
    title: (app) => app,
    loadError: "Could not load details",
    requests: "Subscription requests",
    noRequests: "No subscription requests",
    integration: "Integration",
    account: "Account",
    manager: "Account manager",
    reason: "Rejection reason",
    branches: "Branches",
    appId: "ID",
    appName: "Name in the app",
    statusCol: "Status",
    history: "History",
    attempts: "Attempts",
    send: "Send",
    retry: "Retry send",
    cancelRequest: "Cancel request",
    complete: "Mark subscription completed",
    possiblyDelivered: "Sending was interrupted; the provider may have accepted the message.",
    edit: "Edit integration details",
    integrateNow: "Complete integration",
    addBranches: "Add branches",
    approve: "Approve selected",
    reject: "Reject",
    rejectReason: "Rejection reason (required)",
    deactivateStore: "Deactivate for the store",
    reactivateStore: "Reactivate for the store",
    activateBranches: "Activate selected",
    deactivateBranches: "Deactivate selected",
    showPassword: "Show password",
    hidePassword: "Hide",
    password: "Password",
    readOnly: "View only — you do not have permission to change this.",
    reactivateInfo: "The application is inactive. LUD reactivates it on request.",
    done: "Done.",
    selectBranches: "Select branches first",
    none: "—",
    pendingBranchHint: "Awaiting LUD approval",
    storeLevel: "Store status",
    completeNote: "Note (optional)",
  },
  confirm: {
    cancelTitle: "Cancel request",
    cancelMsg: "The request is cancelled and its history is kept. No email is sent. You can create a new request later.",
    deactivateStoreTitle: "Deactivate for the store",
    deactivateStoreMsg: "All branches of this application become operationally inactive. No data or account is deleted.",
    deactivateBranchesTitle: "Deactivate selected branches",
    deactivateBranchesMsg: "Only the selected branches are deactivated. Their data is kept.",
    completeTitle: "Confirm subscription completed",
    completeMsg: "The store can then complete the integration details.",
    sendTitle: "Send request",
    sendMsg: "The registration email is sent now.",
    yes: "Confirm",
    no: "Go back",
  },
  queueModal: {
    title: "Applications requests",
    subs: "Subscription requests",
    integrations: "Integrations awaiting approval",
    none: "No requests",
    review: "Review",
    store: "Store",
  },
  flow: {
    summaryApp: "Application",
    storeDeactivateTitle: (app) => `Deactivate ${app} for the store`,
    storeDeactivateIntro: "A request to deactivate the whole application for the store. All its active branches stop operating once approved. They stay active until LUD approves, and no data or account is deleted.",
    storeDeactivateConfirm: "The application and all its branches stay active until LUD approves; then the application is deactivated for the whole store. No data is deleted.",
    deactivateStoreBtn: "Deactivate for the store",
    wholeAppTag: "Entire application",
    affectedBranches: "Active branches affected",
    reasonLabel: "Reason for deactivation",
    reasonHint: "Explain why these branches should be deactivated (at least 5 characters). LUD sees it before approving or rejecting.",
    reasonRequired: "A reason for the deactivation is required",
    reasonInvalid: "Write a meaningful reason (at least 5 characters)",
    searchBranches: "Search branches",
    noMatch: "No matching branches",
    removeBranch: "Remove",
    originBranch: "This branch",
    activateBtn: "Activate branches",
    deactivateBtn: "Deactivate branches",
    integrateSteps: ["Account", "Account manager", "Branches", "Review"],
    activateSteps: ["Select branches", "Confirm"],
        editTitle: (app) => `Edit ${app} information`,
    editingRequest: (ref) => `Editing request ${ref}`,
    stepOf: (n, total) => `Step ${n} of ${total}`,
    reviewHint: "This is sent as a request with status “In progress”. Nothing changes live until LUD approves it.",
    passwordMasked: "••••••••",
    passwordUnchanged: "Unchanged (stored one)",
    passwordNew: "New password",
    submitRequest: "Submit request",
    saveChanges: "Save changes",
    requestSent: "The request was sent and is now in progress.",
    requestUpdated: "The request was updated and will be reviewed in its new version.",
    noBranchesSelected: "Select at least one branch",
    selectedBranches: "Selected branches",
    activateTitle: (app) => `Activate ${app} branches`,
    activatePick: "Select the branches to activate. Active branches are not affected.",
    activateNone: "No branch is eligible for activation. Branches need integration details (application ID and name).",
    activateGuide: "Complete the integration information for the branches first.",
    editInfo: "Edit integration information",
    activateConfirm: "An activation request is sent for the branches below only. Every other branch stays as it is.",
    activateSubmit: "Submit activation request",
    deactivateTitle: (app) => `Deactivate ${app} branches`,
    deactivatePick: "Select the active branches to deactivate.",
    deactivateNone: "There are no active branches.",
    deactivateConfirm: "The selected branches stay active until LUD approves; then only these branches are deactivated. Account details and identifiers do not change and nothing is deleted.",
    deactivateSubmit: "Submit deactivation request",
    willChange: "Status will change",
    unaffected: "All other branches are unaffected",
    ineligible: "Not eligible",
    needsInfo: "Needs integration details",
    hasPending: "Has a pending request",
    pendingBadge: (n) => `${n} in review`,
  },
  branchManager: {
    button: "Manage Applications",
    title: (branch) => `Branch applications — ${branch}`,
    hint: "Each application's status for this branch. Every change is sent as a request that LUD approves.",
    loadError: "Could not load the branch applications",
    subscribe: "Subscribe",
    integrate: "Integrate",
    editInfo: "Edit information",
    activate: "Activate",
    deactivate: "Deactivate",
    requests: "Requests",
    pendingRequest: "Request in review",
    subscription: "Subscription",
    readOnly: "View only — you do not have permission to change this.",
  },
  branchAccounts: {
    colApp: "Application",
    colId: "Account ID",
    colName: "Account name",
    colStatus: "Status",
    colActions: "Actions",
    addTitle: (app) => `Add ${app} account`,
    editTitle: (app) => `Edit ${app} account`,
    fieldId: "Account ID (branch in the application)",
    fieldName: "Account name (branch in the application)",
    submit: "Submit for review",
    modalNote: "The change is sent as a request and applied after LUD approves it. The branch status does not change.",
    duplicate: "This ID is used by another branch",
    title: "Application accounts",
    shared: "Store account (shared by all branches)",
    branchOnly: "This branch",
    account: "Account",
    manager: "Account manager",
    password: "Password",
    stored: "Stored (never shown)",
    notSet: "Not added",
    add: "Add",
    edit: "Edit",
    branchId: "Branch ID",
    branchName: "Branch name",
    status: "Integration status",
    approvalNote: "Changes are sent as a request and applied after LUD approves.",
    noApps: "No application data",
    pending: "Request in review",
  },
  requestTypes: { mapping: "Account details", integration: "Integration", activation: "Activation", deactivation: "Deactivation" },
  changeStatus: { inprogress: "In progress", approved: "Approved", rejected: "Rejected", cancelled: "Cancelled" },
  changes: {
    title: "Integration, activation and deactivation requests",
    none: "No requests",
    edit: "Edit",
    cancel: "Cancel request",
    review: "Review",
    by: "By",
    version: (n) => `Version ${n}`,
    rejection: "Rejection reason",
    cancelTitle: "Cancel request",
    cancelMsg: "The request is cancelled and its history is kept. Nothing changes live.",
  },
  reviewModal: {
    wholeApp: "Deactivates the whole application for the store: the store account is closed and every branch stops operating; branch configuration is kept.",
    deactivationReason: "Reason for deactivation",
    title: (type) => `Review ${type} request`,
    current: "Current",
    proposed: "Proposed",
    account: "Account",
    manager: "Account manager",
    branches: "Branches",
    statusChange: "Status change",
    password: "Password",
    passwordChanged: "Will be updated",
    passwordUnchanged: "Unchanged",
    approve: "Approve",
    reject: "Reject",
    reason: "Rejection reason (required)",
    unchanged: "Unchanged",
    stale: "The request changed after you opened it. The latest version was loaded; review it again.",
    history: "History",
  },
  errors: {
    CONFLICTING_REQUEST: "A pending request already exists for a selected branch",
    STALE_VERSION: "The request was changed by someone else. Reload it",
    STALE_REVIEW: "The request changed after you opened it. Review the latest version",
    NOT_EDITABLE: "This request cannot be edited in its current state",
    NOT_PENDING: "This request was already decided",
    INTEGRATION_MISSING: "Complete the integration information before activating branches",
    INTEGRATION_NOT_APPROVED: "The integration has not been approved yet",
    BRANCH_NOT_ACTIVE: "Only active branches can be deactivated",
    DUPLICATE_APP_ID: "A branch application ID is now used by another branch",
    INVALID_TYPE: "Unknown request type",
    ACCESS_DENIED: "You do not have permission for this action",
    STORE_INCOMPLETE: "Store information is incomplete",
    NO_BRANCHES: "Select at least one branch",
    BRANCH_NOT_ELIGIBLE: "A selected branch is missing required information",
    BRANCH_NOT_IN_STORE: "A selected branch does not belong to this store",
    DUPLICATE_REQUEST: "A registration request already exists for a selected branch",
    APP_EMAIL_NOT_CONFIGURED: "This application's email is not configured. Contact support",
    APP_EMAIL_INVALID: "The configured application email is invalid",
    STORE_EMAIL_INVALID: "The store email is missing or invalid",
    EMAIL_DISABLED: "Email sending is disabled on the server",
    ALREADY_SENDING: "The request is already being sent",
    ALREADY_SENT: "The request was already sent",
    CANNOT_CANCEL: "This request cannot be cancelled in its current state",
    NOT_SENT: "Only a sent request can be marked completed",
    SUBSCRIPTION_NOT_COMPLETED: "A selected branch's registration request is not completed yet",
    INTEGRATION_CLOSED: "The integration is deactivated. LUD reactivates it on request",
    INTEGRATION_ACTIVE: "The account of an active integration cannot be changed here",
    BRANCH_ALREADY_ACTIVE: "A selected branch is already active",
    VALIDATION_FAILED: "Check the highlighted fields",
    REASON_REQUIRED: "A rejection reason is required",
    STORE_NOT_ACTIVE: "The application is not active for the store. Reactivate it first",
    BRANCH_NOT_MAPPED: "A selected branch has no application ID",
    SEND_FAILED: "Sending the email failed",
    generic: "Something went wrong. Please try again",
  },
};

export const applicationsText = (lang) => (lang === "en" ? en : ar);

// Message for an API error: localized by its code, else the server's message.
export const errorMessage = (t, error) => t.errors[error?.code] || error?.message || t.errors.generic;
